import { queryOptions } from "@tanstack/react-query";
import type { CustomerResponse } from "@/app/billing/types";
import { getCoordinatorApi } from "@/lib/api";
import { billingKeys } from "./query-keys";

export type UpdateCustomerRequest = {
  name: string;
};

const fetchCustomer = async ({
  organizationId,
}: {
  organizationId: string;
}): Promise<CustomerResponse> => {
  const api = getCoordinatorApi({ organizationId });
  const { data } = await api.get<CustomerResponse>("/customer");
  return data;
};

export const updateCustomer = async ({
  data,
  organizationId,
}: {
  data: UpdateCustomerRequest;
  organizationId: string;
}): Promise<CustomerResponse> => {
  const api = getCoordinatorApi({ organizationId });
  const { data: responseData } = await api.put<CustomerResponse>(
    "/customer",
    data
  );
  return responseData;
};

export const customerQueryOptions = ({
  organizationId,
}: {
  organizationId: string;
}) =>
  queryOptions<CustomerResponse>({
    queryKey: billingKeys.customer(organizationId),
    queryFn: () => fetchCustomer({ organizationId }),
  });
